import "../../../../../styles/global.css";
import { getCalendarCells } from "../../../../../utils/getCalendarCells";

const DateTimeCalendar = ({
  selectedDate,
  setSelectedDate,
  currentYear,
  currentMonth,
}) => {
  const calendarCells = getCalendarCells(currentYear, currentMonth);
  const formatDate = (dateObj) => {
    if (!dateObj) return "";
    const date = new Date(dateObj);
    if (isNaN(date)) return "";
    return date.toISOString().split("T")[0];
  };
  const daysOfWeek = ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub", "Ned"];

  const splitIntoChunks = (array, chunkSize = 7) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  };

  const cellsToDisplay = splitIntoChunks(calendarCells, 7).filter((week) =>
    // zadrži nedelju samo ako ima bar jedan dan iz trenutnog meseca
    week.some((day) => day.currentMonth)
  );

  return (
    <>
      <div className="flex-direction-row gap-4 width-100 justify-between calendar-days-of-week">
        {daysOfWeek.map((day) => (
          <div
            key={day}
            className="flex-direction-row items-center justify-center"
          >
            <p className="font-14 inria-sans-700">{day}</p>
          </div>
        ))}
      </div>

      <div className="flex-direction-column">
        <div className="flex-direction-column gap-4">
          {cellsToDisplay && (
            <div className="flex-direction-column gap-4">
              {cellsToDisplay.map((week, index) => (
                <div
                  className="flex-direction-row gap-4 width-100 justify-between"
                  key={index}
                >
                  {week.map((day, index) => (
                    <div
                      key={index}
                      className="flex-direction-row items-center justify-center calendar-day pointer"
                      onClick={() => {
                        if (day.currentMonth) {
                          setSelectedDate(day.date);
                        }
                      }}
                    >
                      <p
                        className={`inria-sans-400 font-14 flex-direction-row items-center justify-center ${
                          day.currentMonth
                            ? "day-current-month"
                            : "day-other-month"
                        } ${
                          formatDate(day.date) === formatDate(selectedDate)
                            ? "selected-day"
                            : ""
                        }`}
                      >
                        {day.day}
                      </p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
export default DateTimeCalendar;
